// extracted by mini-css-extract-plugin
export var filterIncDec = "_dt-0";
export var leftBorder = "_dt-1";
export var rightBorder = "_dt-2";
export var stringInput = "_dt-3";